'use client';

import { useEffect, useRef, useState } from 'react';
import { Link } from '@/app_components/common/Link';
import { cn } from '@/app_lib/utils/utils';

export const TradingViewScript = () => {
  const container = useRef<HTMLDivElement>(null);
  const scriptLoader = useRef(false);
  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    if (!scriptLoader.current) {
      const script = document.createElement('script');

      script.onerror = () => setScriptLoaded(true);
      script.onload = () => setScriptLoaded(true);
      script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-tickers.js';
      script.type = 'text/javascript';
      script.async = true;
      script.innerHTML = `
    {
      "symbols": [
        {
          "description": "",
          "proName": "NASDAQ:IXIC"
        },
        {
          "description": "",
          "proName": "NYSE:NYA"
        },
        {
          "description": "",
          "proName": "FRED:DJIA"
        },
        {
          "description": "",
          "proName": "FXOPEN:SPXM"
        }
      ],
      "isTransparent": true,
      "showSymbolLogo": true,
      "colorTheme": "light",
      "locale": "en"
    }`;

      container.current?.appendChild(script);
      scriptLoader.current = true;
    }
  }, []);

  return (
    <div
      className={cn(
        'tradingview-widget-container container-ft w-full [&_iframe]:border-b [&_iframe]:stroke-secondary [&_iframe]:w-[1344px]! overflow-x-scroll scrollbar-hidden',
        !scriptLoaded && 'h-[104px] animate-pulse bg-helper',
      )}
      ref={container}
    >
      <div className='tradingview-widget-container__widget ' />
      <div className='tradingview-widget-copyright pl-4 md:pl-6 flex items-start'>
        <Link
          aria-label='Go to the main page on TradingView website'
          className={cn('blue-text', !scriptLoaded && 'hidden')}
          href='https://www.tradingview.com/'
          recipe='content'
          rel='noopener nofollow noreferrer'
          target='_blank'
          variant='primary'
        >
          Track all markets on TradingView
        </Link>
      </div>
    </div>
  );
};
